import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import styled from 'styled-components';
import { useHistory } from 'react-router-dom';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import { useTranslation } from 'react-i18next';
import { useForm } from 'react-hook-form';
import { useAlert, types } from 'react-alert';
import { SelectFacility, SelectPrefecture, ConfirmDialog, ErroDialog, VerticalHeadTable, PrimaryButton, GoogleMap, } from '../../components';
import * as Constants from '../../common/constants';
import { useMaster, useApplyClinic, useGoogleMap } from '../../../model/hooks';
import { Application } from '../../../model/firestore_model';
import { useChangeEvent } from '../../../model/hooks/common/ChangeEventHooks';
const useStyles = makeStyles((theme) => ({
    layout: {
        width: 'auto',
        marginLeft: theme.spacing(2),
        marginRight: theme.spacing(2),
        paddingTop: theme.spacing(3),
        paddingBottom: theme.spacing(3),
        [theme.breakpoints.up(600 + theme.spacing(2) * 2)]: {
            width: 600,
            marginLeft: 'auto',
            marginRight: 'auto',
            paddingTop: theme.spacing(6),
            paddingBottom: theme.spacing(6),
        },
    },
    paper: {
        padding: theme.spacing(2),
        [theme.breakpoints.up(600 + theme.spacing(3) * 2)]: {
            padding: theme.spacing(3),
        },
    },
}));
export const Apply = () => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    const { t } = useTranslation();
    const history = useHistory();
    const classes = useStyles();
    const reactAlert = useAlert();
    const { register, errors, handleSubmit } = useForm();
    const { applyClinicMaster } = useMaster();
    const { loading, applyClinic } = useApplyClinic();
    const { loadingGeocode, geocoding } = useGoogleMap();
    const { changeText, changeNumSelect } = useChangeEvent();
    const [corporateName, setCorporateName] = useState('');
    const [facilityName, setFacilityName] = useState('');
    const [facilityDiv, setFacilityDiv] = useState(0);
    const [tel, setTel] = useState('');
    const [mailaddress, setMailaddress] = useState('');
    const [prefecture, setPrefecture] = useState(0);
    const [prefectureLabel, setPrefectureLabel] = useState('');
    const [address, setAddress] = useState('');
    const [lat, setLat] = useState(0);
    const [lng, setLng] = useState(0);
    const [lastName, setLastName] = useState('');
    const [firstName, setFirstName] = useState('');
    const [isOpenDialog, setIsOpenDialog] = useState(false);
    const [isOpenErrorDialog, setIsOpenErrorDialog] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [isLockMap, setIsLockMap] = useState(true);
    const onChangePrefecture = (e, child) => {
        setIsLockMap(true);
        setPrefecture(e.target.value);
        setPrefectureLabel(child.props.children);
    };
    const onChangeAddress = (e) => {
        setIsLockMap(true);
        setAddress(e.target.value);
    };
    const onSubmitForm = () => {
        setIsOpenDialog(true);
    };
    const onCloseDialog = () => setIsOpenDialog(false);
    const onCloseErrorDialog = () => {
        setErrorMessage('');
        setIsOpenErrorDialog(false);
    };
    const onClickCheckMap = async () => {
        try {
            const result = await geocoding(`${prefectureLabel}${address}`);
            setLat(result.lat);
            setLng(result.lng);
            setIsLockMap(false);
        }
        catch (e) {
            reactAlert.show(t('エラーが発生しました'), { type: types.ERROR });
        }
    };
    const onDragEnd = (lat, lng) => {
        setLat(lat);
        setLng(lng);
        reactAlert.show(t('地図上の位置を更新しました'), { type: types.SUCCESS });
    };
    const onClickApply = async () => {
        try {
            onCloseDialog();
            const item = Application.Clinic.fromRawValue(corporateName, facilityName, facilityDiv, tel, mailaddress, prefecture, address, firstName, lastName, lat, lng);
            await applyClinic(item);
            history.push('/apply/complete');
        }
        catch (e) {
            if (e instanceof Error) {
                setErrorMessage(e.message);
                setIsOpenErrorDialog(true);
            }
        }
    };
    const applyData = [
        { th: t('契約者名'), td: corporateName },
        { th: t('施設名'), td: facilityName },
        { th: t('施設区分'), td: (_c = (_b = (_a = applyClinicMaster) === null || _a === void 0 ? void 0 : _a.facilityList) === null || _b === void 0 ? void 0 : _b.find((d) => d.id === facilityDiv)) === null || _c === void 0 ? void 0 : _c.text },
        { th: t('姓'), td: lastName },
        { th: t('名'), td: firstName },
        { th: t('電話番号'), td: tel },
        { th: t('メールアドレス'), td: mailaddress },
        { th: t('都道府県'), td: (_f = (_e = (_d = applyClinicMaster) === null || _d === void 0 ? void 0 : _d.prefectureList) === null || _e === void 0 ? void 0 : _e.find((d) => d.id === prefecture)) === null || _f === void 0 ? void 0 : _f.text },
        { th: t('市区町村番地'), td: address },
    ];
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: classes.layout },
            React.createElement(Paper, { className: classes.paper, elevation: 4 },
                React.createElement(STitle, { variant: "h5", align: "center" }, t('申込フォーム')),
                React.createElement("div", { style: { marginTop: '24px' } },
                    React.createElement(SSubTitle, null, t('クリニック情報入力')),
                    React.createElement("form", { onSubmit: handleSubmit(onSubmitForm), autoComplete: "off" },
                        React.createElement(Grid, { container: true, spacing: 3 },
                            React.createElement(Grid, { item: true, xs: 12 },
                                React.createElement(TextField, { required: true, label: t('契約者名'), value: corporateName, onChange: changeText(setCorporateName), fullWidth: true })),
                            React.createElement(Grid, { item: true, xs: 12 },
                                React.createElement(TextField, { required: true, label: t('施設名'), value: facilityName, onChange: changeText(setFacilityName), fullWidth: true })),
                            React.createElement(Grid, { item: true, xs: 12 },
                                React.createElement(SelectFacility, { value: facilityDiv, menuItems: (_h = (_g = applyClinicMaster) === null || _g === void 0 ? void 0 : _g.facilityList) === null || _h === void 0 ? void 0 : _h.map((d) => {
                                        return { value: d.id, text: d.text };
                                    }), onChange: changeNumSelect(setFacilityDiv) })),
                            React.createElement(Grid, { item: true, xs: 12, sm: 6 },
                                React.createElement(TextField, { required: true, label: t('姓'), value: lastName, onChange: changeText(setLastName), fullWidth: true })),
                            React.createElement(Grid, { item: true, xs: 12, sm: 6 },
                                React.createElement(TextField, { required: true, label: t('名'), value: firstName, onChange: changeText(setFirstName), fullWidth: true })),
                            React.createElement(Grid, { item: true, xs: 12 },
                                React.createElement(TextField, { required: true, label: t('電話番号(数字のみ)'), name: "tel", inputRef: register({ pattern: Constants.REGEX.TEL }), error: Boolean(errors.tel), helperText: errors.tel && t('正しい形式で入力してください'), onChange: changeText(setTel), fullWidth: true })),
                            React.createElement(Grid, { item: true, xs: 12 },
                                React.createElement(TextField, { required: true, label: t('メールアドレス'), name: "mailaddress", inputRef: register({ pattern: Constants.REGEX.EMAIL }), error: Boolean(errors.mailaddress), helperText: errors.mailaddress && t('正しい形式で入力してください'), onChange: changeText(setMailaddress), fullWidth: true })),
                            React.createElement(Grid, { item: true, xs: 12 },
                                React.createElement(SelectPrefecture, { value: prefecture, menuItems: (_k = (_j = applyClinicMaster) === null || _j === void 0 ? void 0 : _j.prefectureList) === null || _k === void 0 ? void 0 : _k.map((d) => {
                                        return { value: d.id, text: d.text };
                                    }), onChange: onChangePrefecture })),
                            React.createElement(Grid, { item: true, xs: 12 },
                                React.createElement(TextField, { required: true, label: t('市区町村番地'), value: address, onChange: onChangeAddress, fullWidth: true })),
                            React.createElement(Grid, { item: true, xs: 12 },
                                React.createElement(PrimaryButton, { inverted: true, size: "small", loading: loadingGeocode, onClick: onClickCheckMap }, "\u4F4F\u6240\u304B\u3089\u5730\u56F3\u3092\u78BA\u8A8D"),
                                React.createElement(SHelperText, null, t('※ピンを移動することで位置を調整できます'))),
                            React.createElement(Grid, { item: true, xs: 12 },
                                React.createElement(GoogleMap, { lat: lat, lng: lng, disabled: isLockMap, onDragEnd: onDragEnd }))),
                        React.createElement(SButtonArea, null,
                            React.createElement(PrimaryButton, { type: "submit", loading: loading, disabled: isLockMap }, t('入力内容確認'))))))),
        React.createElement(ConfirmDialog, { isOpen: isOpenDialog, title: t('申込内容確認'), positiveLabel: t('申し込む'), negativeLabel: t('キャンセル'), onClose: onCloseDialog, onClickNegative: onCloseDialog, onClickPositive: onClickApply, loading: loading },
            React.createElement(React.Fragment, null,
                React.createElement(VerticalHeadTable, { data: applyData }),
                React.createElement(GoogleMap, { lat: lat, lng: lng, disabled: false, draggable: false }),
                React.createElement(SCheckMessage, null, t('上記の内容で申し込みますか？')))),
        React.createElement(ErroDialog, { isOpen: isOpenErrorDialog, title: t('エラー'), onClose: onCloseErrorDialog }, errorMessage)));
};
const STitle = styled(Typography) `
  font-weight: bold;
  color: #777;
`;
const SSubTitle = styled(Typography) `
  font-weight: bold;
`;
const SButtonArea = styled.div `
  padding-top: 32px;
  display: flex;
  justify-content: flex-end;
`;
const SCheckMessage = styled.div `
  text-align: right;
  margin-top: 32px;
  font-weight: bold;
`;
const SHelperText = styled.p `
  &&& {
    margin-top: 8px;
    margin-bottom: 0;
    color: ${Constants.COLOR.ORANGE700};
    font-size: 14px;
  }
`;
